import { Button, type TPlacement, TooltipDesktop } from '@cian/ui-kit';
import { type TButtonTheme } from '@cian/ui-kit/button/types';

import { clsx } from 'clsx';
import { type FC, type ReactNode } from 'react';

import styles from './ControlButton.css';

type ActiveThemes = {
  [key in TButtonTheme]?: TButtonTheme;
};

const ACTIVE_THEMES: ActiveThemes = {
  fill_white_primary: 'fill_primary',
};

export type ControlButtonProps = {
  handleClick: React.MouseEventHandler<HTMLButtonElement>;
  icon?: JSX.Element;
  theme?: TButtonTheme;
  tooltipPlacement?: TPlacement;
  tooltipTitle?: ReactNode;
  className?: string;
  isActive?: boolean;
  testId?: string;
};

export const ControlButton: FC<ControlButtonProps> = props => {
  const {
    handleClick,
    icon,
    theme = 'fill_white_primary',
    tooltipPlacement = 'left',
    tooltipTitle,
    className,
    isActive,
    testId,
  } = props;

  const themeComputed = isActive ? ACTIVE_THEMES[theme] : theme;

  const content = (
    <span className={clsx(styles['control-button'], className)}>
      <Button beforeIcon={icon} data-testid={testId} size="XS" theme={themeComputed} onClick={handleClick} />
    </span>
  );

  if (tooltipTitle) {
    return (
      <TooltipDesktop placement={tooltipPlacement} title={tooltipTitle}>
        {content}
      </TooltipDesktop>
    );
  }

  return content;
};
